import { useDelete, useGet, usePost } from '@/api/lib/integration';

export const getBanksApiUserToken = useGet<void, { token: string }>('/api/banks-api/token');

export const createBanksApiUser = usePost<void, { id: number }>('/api/banks-api/user');

export const deleteBanksApiUser = useDelete<void, void>('/api/banks-api/user');

export const notifyAccountCreated = usePost<void, void>('/api/banks-api/accounts-changed');
